module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "qr",
    class: _vm.disabled === true ? 'disabled' : ''
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.qrImg)
    }
  }), _vm._v(" "), (_vm.status && _vm.status.length > 0) ? _c('v-stamp', {
    staticClass: "stamp",
    attrs: {
      "title": _vm.status,
      "color": "#898989"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c18da00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/qr-code.vue
// module id = 862
// module chunks = 34